var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.054l-5.073 5.073a.724.724 0 01-.522.212.707.707 0 01-.532-.212.717.717 0 01-.217-.527c0-.206.072-.382.217-.527L10.946 12 5.873 6.927a.725.725 0 01-.212-.522.707.707 0 01.212-.532.717.717 0 01.527-.217c.206 0 .382.072.527.217L12 10.946l5.073-5.073a.724.724 0 01.522-.212.707.707 0 01.532.212c.145.145.217.32.217.527a.717.717 0 01-.217.527L13.054 12l5.073 5.073c.138.139.21.313.212.522a.707.707 0 01-.212.532.717.717 0 01-.527.217.717.717 0 01-.527-.217L12 13.054z",
    fill: "currentColor"
  })));
}
SvgClose.displayName = 'Close';
export default SvgClose;